import 'ember-statechart-component';
import './icons.ts';

import Application from '@ember/application';
import setupInspector from '@embroider/legacy-inspector-support/ember-source-4.12';
import { isDevelopingApp, macroCondition } from '@embroider/macros';

import PageTitleService from 'ember-page-title/services/page-title';

import '@nullvoxpopuli/limber-shared/theme.css';

import Router from './router.ts';

// @babel/traverse (from babel-plugin-ember-template-imports)
// accesses process.....
// maybe one day we can have a browser-only verison?
// But they aren't used.... so.. that's fun.
//
// There is no Buffer stub on purpose.
// esm.sh's node shims prefer a global Buffer,
// and a stub without `from` breaks modules loaded from there.
Object.assign(window, {
  process: { env: {} },
});

export default class App extends Application {
  inspector = setupInspector(this);
  modules = {
    './router': Router,
    ...import.meta.glob('./routes/{edit,index,application,error-404}.ts', { eager: true }),
    ...import.meta.glob('./services/{editor,status}.ts', { eager: true }),
    ...import.meta.glob('./controllers/*.ts', { eager: true }),
    ...import.meta.glob('./templates/{application,edit,output,error-404}.gts', {
      eager: true,
    }),

    // /////////////////
    // To keep
    // /////////////////
    './services/page-title': PageTitleService,
  };
}

if (macroCondition(isDevelopingApp())) {
  Object.assign(App, {
    LOG_RESOLVER: true,
    LOG_ACTIVE_GENERATION: true,
    LOG_TRANSITIONS: true,
    LOG_TRANSITIONS_INTERNAL: true,
    LOG_VIEW_LOOKUPS: true,
  });
}
